import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const createPpeComponentQuery = (data) => {
  return axios.post(apiurl?.createPpeComponent, data);
};

const createPpeComponent = () => {
  const queryClient = useQueryClient();
  return useMutation(createPpeComponentQuery, {
    onSuccess: () => {
      showAlert('PPE Component Added Successfully!', 'success');
      queryClient.invalidateQueries('getPpeComponentList');
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};

export default createPpeComponent;
